import { z } from "zod";

// t("IN_HOUSE")
// t("EXTERNAL")
export const prescriptionTypeEnum = z.enum(["IN_HOUSE", "EXTERNAL"]);

export type PrescriptionType = z.infer<typeof prescriptionTypeEnum>;
